import keys from '@debbie/common/dist/cache/keys.js';
import { TemplateState } from '@debbie/common/dist/templates/index.js';
import * as templatesAPI from '@debbie/cortex/dist/api/templates.js';
import { selectExclusiveContent } from '@debbie/cortex/dist/exclusiveContent/selectors.js';
import { h } from '@debbie/cortex/dist/index.js';
import { useMe } from '@debbie/cortex/dist/me/index.js';
import q from '@debbie/cortex/dist/query.js';
import { templatesEntity } from '@debbie/cortex/dist/templates/index.js';
import moment from 'moment';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import THEME from '../../../theme.js';
import { PARSE_RESULT_TYPE, parseText } from '../../../utils/templates.js';
import Button from '../../Button.js';
import { Edit, PlusCircle } from '../../Icons/index.js';
import { Badge, ButtonGroup, Input, Modal, PlaceholderLoader, } from '../../index.js';
import { TypeStyled } from '../Templates.js';
const Header = (props) => {
    const { defaultTemplate, template, mentionSuggestions } = props;
    const lang = useSelector((s) => s.lang);
    const meLoadable = useMe();
    const me = h.hasData(meLoadable) ? meLoadable.data : null;
    const exclusiveContent = useSelector(selectExclusiveContent);
    const [state, setState] = useState({
        loadingSaveDraft: false,
        loadingPublishVersion: false,
    });
    const [savingAndPublishing, setSavingAndPublishing] = useState(false);
    const [savingDraft, setSavingDraft] = useState(false);
    const [publishing, setPublishing] = useState(false);
    const [editNameModalOpen, setEditNameModalOpen] = useState(false);
    const getCurrentTemplate = () => {
        return {
            ...template,
            public: undefined,
            subject: parseText(props.subject, mentionSuggestions, PARSE_RESULT_TYPE.TEXT),
            text: parseText(props.content, mentionSuggestions, PARSE_RESULT_TYPE.TEXT),
            html: parseText(props.content, mentionSuggestions),
            intent: props.intent,
        };
    };
    const saveAndPublish = async () => {
        setState({ ...state, loadingSaveDraft: true });
        setSavingAndPublishing(true);
        const newVersion = await save();
        await publish(newVersion.versionId);
        setState({ ...state, loadingSaveDraft: false });
        props.setTemplate({
            ...getCurrentTemplate(),
            state: TemplateState.DRAFT,
            versionId: newVersion.versionId,
        });
        setSavingAndPublishing(false);
    };
    const saveDraftOnly = async () => {
        setSavingDraft(true);
        const newVersion = await save();
        props.setTemplate({
            ...getCurrentTemplate(),
            state: TemplateState.DRAFT,
            versionId: newVersion.versionId,
        });
        setSavingDraft(false);
    };
    const publishOnly = async () => {
        setPublishing(true);
        if (template.versionId) {
            publish(template.versionId);
        }
        props.setTemplate({
            ...getCurrentTemplate(),
            state: TemplateState.PUBLISHED,
            versionId: template.versionId,
        });
        setPublishing(false);
    };
    const save = async () => {
        const newVersion = template &&
            (await templatesAPI.saveDraft({
                ...getCurrentTemplate(),
                isDefaultLang: props.selectedLanguage === template.lang && template.isDefaultLang,
                lang: props.selectedLanguage,
                isForAlternativeContact: props.ac,
                versionId: null,
            }));
        return newVersion;
    };
    const publish = async (versionId) => {
        setState({ ...state, loadingPublishVersion: true });
        console.log({ versionId });
        try {
            const _versionId = versionId || template?.versionId;
            _versionId &&
                (await templatesAPI.publishVersion(_versionId, props.ac, props.selectedLanguage === template.lang && template.isDefaultLang));
            q.invalidate(keys.write.modify(templatesEntity, props.templateId));
            props.setTemplate({
                ...getCurrentTemplate(),
                state: TemplateState.PUBLISHED,
            });
        }
        catch (error) {
            alert(error);
        }
        setState({ ...state, loadingPublishVersion: false });
    };
    return (React.createElement(StyledHeader, null,
        defaultTemplate &&
            (!defaultTemplate.public ||
                (me && exclusiveContent?.includes(me.id))) && (React.createElement(ButtonGroup, { style: {
                float: 'right',
            } },
            React.createElement(Button, { size: "small", disabled: !(props.changesNotSaved || template.versionId === null), onClick: saveAndPublish, loading: savingAndPublishing }, lang.templates.saveAndPublish),
            React.createElement(Button, { size: "small", 
                // disabled={
                //   props.subjectValidationErrors.length > 0 ||
                //   props.editorValidationErrors.length > 0
                // }
                theme: "secondary", onClick: () => props.toggleModal('preview') }, lang.templates.preview),
            React.createElement(SettingsButton, { size: "small", theme: "secondary", dropdown: [
                    {
                        value: lang.templates.versions,
                        theme: 'secondary',
                        onClick: () => {
                            props.toggleModal('versions');
                        },
                    },
                    {
                        value: lang.templates.saveDraft,
                        theme: 'secondary',
                        onClick: () => {
                            saveDraftOnly();
                        },
                    },
                    {
                        value: lang.templates.publish,
                        theme: 'secondary',
                        onClick: () => {
                            publishOnly();
                        },
                    },
                    {
                        value: lang.templates.copyOtherTemplate,
                        theme: 'secondary',
                        onClick: () => props.toggleModal('copyTemplate'),
                    },
                    {
                        value: lang.templates.settings,
                        theme: 'secondary',
                        onClick: () => props.toggleModal('settings'),
                    },
                ] }))),
        React.createElement("h1", null,
            !defaultTemplate || props.loading ? (React.createElement(PlaceholderLoader, null)) : (defaultTemplate.name),
            ' ',
            !defaultTemplate?.public && (React.createElement(Edit, { style: {
                    width: '16px',
                    cursor: 'pointer',
                }, onClick: () => {
                    setEditNameModalOpen(!editNameModalOpen);
                } }))),
        defaultTemplate?.name && editNameModalOpen && (React.createElement(Modal, { onToggle: () => {
                setEditNameModalOpen(!editNameModalOpen);
            }, header: defaultTemplate.name },
            React.createElement(EditName, { templateId: props.templateId, name: defaultTemplate.name, onDone: (name) => {
                    props.setTemplate({
                        ...getCurrentTemplate(),
                        name,
                    });
                    setEditNameModalOpen(!editNameModalOpen);
                } }))),
        React.createElement("p", null,
            defaultTemplate && (React.createElement(TypeStyled, { type: defaultTemplate.type }, lang.templateTypes[defaultTemplate.type])),
            ' ',
            defaultTemplate &&
                defaultTemplate.createdAt &&
                `${lang.templates.lastChangedOn} ${moment(defaultTemplate.createdAt).format(THEME.DATE_FORMAT_LONG)}`,
            ' ',
            !defaultTemplate?.public && (React.createElement(PlusCircle, { "data-tooltip-content": lang.templates.addTag, "data-tooltip-id": "tooltip-default", style: { verticalAlign: 'text-top' }, onClick: () => props.toggleModal('addTag') })),
            ' ',
            !!defaultTemplate?.tags?.length &&
                defaultTemplate.tags.map(({ tag }) => (React.createElement(Badge, { key: tag, theme: THEME.COLOR_ACCENT, style: { marginRight: '2px' } }, lang.templateTags[tag]))),
            React.createElement("span", { style: { float: 'right', minWidth: '20%', textAlign: 'right' } }, savingAndPublishing || savingDraft || publishing ? (React.createElement(PlaceholderLoader, null)) : (React.createElement(React.Fragment, null, defaultTemplate &&
                (defaultTemplate.state === TemplateState.VERSION ||
                    defaultTemplate.state === TemplateState.DRAFT)
                ? `${lang.templates.WIP}`
                : defaultTemplate &&
                    defaultTemplate.state === TemplateState.PUBLISHED
                    ? `${lang.templates.versionPublished}`
                    : ''))))));
};
export default Header;
const SettingsButton = styled(Button) `
  .dropdown-menu {
    left: auto;
    right: 0;
  }
`;
const StyledHeader = styled.div `
  h1 {
    font-size: 2.5em;
    margin-bottom: 0;
  }

  p {
    color: ${THEME.DARK_COLOR_SECONDARY};
    font-weight: bold;
    font-size: 0.9em;
  }
`;
const EditName = (props) => {
    const lang = useSelector((s) => s.lang);
    const [name, setName] = useState(props.name);
    return (React.createElement("div", null,
        React.createElement(Input, { placeholder: lang.templates.name, value: name, onChange: (e) => setName(e.target.value), autofocus: true, onSubmit: name != props.name && name
                ? async () => {
                    try {
                        await templatesAPI.patch(props.templateId, {
                            name,
                        });
                        props.onDone(name);
                    }
                    catch (error) {
                        alert('Error');
                    }
                }
                : undefined })));
};
//# sourceMappingURL=Header.js.map